import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const fmtD = (iso) => (iso ? iso.split("-").reverse().join(".") : "—");

export const FuelConsumptionTable = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/cars/fuel-consumption-table").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, []);
  if (!rows || rows.length === 0) return null;
  return (
    <div className="card-flat p-4" data-testid="fuel-consumption-table">
      <h2 className="font-display text-lg font-bold mb-3">📊 Consumuri mașini (pe baza alimentărilor)</h2>
      <div className="overflow-x-auto border border-zinc-200 rounded">
        <table className="w-full text-xs">
          <thead className="bg-zinc-100 text-zinc-600">
            <tr>
              <th className="text-left px-2 py-1.5 font-semibold">Mașina</th>
              <th className="text-right px-2 py-1.5 font-semibold">Alimentări</th>
              <th className="text-right px-2 py-1.5 font-semibold">Total litri</th>
              <th className="text-right px-2 py-1.5 font-semibold">Km parcurși</th>
              <th className="text-right px-2 py-1.5 font-semibold">Medie L/100km</th>
              <th className="text-right px-2 py-1.5 font-semibold">Min–Max</th>
              <th className="text-right px-2 py-1.5 font-semibold">Ultimul consum</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const abn = Math.abs(r.last_deviation_pct) >= 35;
              return (
                <tr key={r.car_id} className="border-t border-zinc-100 hover:bg-amber-50/40" data-testid={`fuel-cons-row-${r.car_id}`}>
                  <td className="px-2 py-1.5 font-semibold whitespace-nowrap">🚐 {r.car_label}</td>
                  <td className="px-2 py-1.5 text-right tabular-nums">{r.fills}</td>
                  <td className="px-2 py-1.5 text-right tabular-nums">{r.total_liters} L</td>
                  <td className="px-2 py-1.5 text-right tabular-nums">{r.total_km} km</td>
                  <td className="px-2 py-1.5 text-right font-bold tabular-nums">{r.avg_l100}</td>
                  <td className="px-2 py-1.5 text-right text-zinc-500 tabular-nums">{r.min_l100} – {r.max_l100}</td>
                  <td className="px-2 py-1.5 text-right whitespace-nowrap tabular-nums">
                    <span className={abn ? (r.last_deviation_pct > 0 ? "font-black text-red-600" : "font-black text-blue-600") : "font-semibold"}>
                      {r.last_l100}
                    </span>
                    {abn && <span className="ml-1 text-[10px] font-bold">{r.last_deviation_pct > 0 ? "🔺" : "🔻"}{r.last_deviation_pct > 0 ? "+" : ""}{r.last_deviation_pct}%</span>}
                    <span className="text-[10px] text-zinc-400"> · {fmtD(r.last_date)}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="text-[10px] text-zinc-400 mt-1.5">Consum calculat între alimentări consecutive (litri ÷ km parcurși × 100). Roșu 🔺 = mult peste media mașinii, albastru 🔻 = mult sub.</div>
    </div>
  );
};
